import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'Limit'
})
export class LimitPipe implements PipeTransform
{
    defaultLimit = 15;

    transform(value: any, limit: number = this.defaultLimit)
    {
        if (!value) { return value; }
        if (limit && limit < 1)
        {
            limit = this.defaultLimit;
        }

        if (value.length > limit)
        {
            return value.substr(0, limit) + ' ...';
        }

        return value;
    }

}
